import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import queryString from 'query-string';
import originalMoment from 'moment';
import { extendMoment } from 'moment-range';
import find from 'ramda/src/find';
import propEq from 'ramda/src/propEq';
import ResponsiveTabs from '@components/@core/ResponsiveTabs';
import Tab from '@components/@core/Tab';
import VendorActions from '~/actions/vendor';
import { PRODUCT_REPORTS_TABS } from '~/services/constants';
import Ratings from './Ratings';
import Visibility from './Visibility';
import Competition from './Competition';
import Trends from './Trends';

const moment = extendMoment(originalMoment);

const VendorRatings = ({ data }) => {
    const dispatch = useDispatch();
    const location = useLocation();
    const { tab } = queryString.parse(location.search);

    const vrCompanies = useSelector((state) => state.vendor.companies);
    const company = find(propEq('id', data.id), vrCompanies);

    const dateStart = moment().subtract(2, 'years');
    const [date, setDate] = useState(moment.range(dateStart.format('YYYY-MM-DD'), moment().format('YYYY-MM-DD')));
    const [active, setActive] = useState(tab || 'ratings');

    useEffect(() => {
        getCompanyDetail(dateStart.format('YYYY-MM-DD'), moment().format('YYYY-MM-DD'));
    }, []);

    const handleDate = (e) => {
        setDate(moment.range(e.start.format('YYYY-MM-DD'), e.end.format('YYYY-MM-DD')));
        getCompanyDetail(e.start.format('YYYY-MM-DD'), e.end.format('YYYY-MM-DD'));
    };

    const getCompanyDetail = (date_start, date_end) => {
        dispatch(VendorActions.getvrcompanyRequest(data.id, { date_start, date_end }));
    };

    return (
        <div className="product-ratings-reports">
            <p className="card-header dsl-b22 bold">Product Ratings Reports</p>
            <ResponsiveTabs className="card-content pb-3" active={active} data={PRODUCT_REPORTS_TABS} onTab={(e) => setActive(e.id)} />
            <Tab eventKey="ratings" active={active}>
                {company && <Ratings data={company} date={date} onDateChange={handleDate} />}
            </Tab>
            <Tab eventKey="rating-trends" active={active}>
                {company && <Trends company={company} date={date} onDateChange={handleDate} />}
            </Tab>
            <Tab eventKey="visibility" active={active}>
                {company && <Visibility company={company} date={date} onDateChange={handleDate} />}
            </Tab>
            <Tab eventKey="category" active={active}>
                <p className="dsl-b18 bold">Category</p>
            </Tab>
            <Tab eventKey="competition" active={active}>
                <Competition company={company} date={date} onDateChange={handleDate} />
            </Tab>
            <Tab eventKey="nps" active={active}>
                <p className="dsl-b18 bold">NPS</p>
            </Tab>
            <Tab eventKey="dealer-satisfaction-award" active={active}>
                <p className="dsl-b18 bold">Dealer Satisfaction Award</p>
            </Tab>
        </div>
    );
};

export default VendorRatings;
